import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './styles/index.css'

// Registrar service worker para PWA
// Solo registrar en contextos seguros (HTTPS o localhost) y cuando el SW está disponible
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    // En desarrollo con Vite, el SW es manejado por vite-plugin-pwa
    // Solo intentamos registrar manualmente en producción
    if (import.meta.env.PROD) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('SW registrado:', registration.scope)
        })
        .catch((error) => {
          // No es crítico si falla - la app funciona sin SW
          console.warn('SW registro falló:', error)
        })
    }
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
